import { render, staticRenderFns } from "./GalleryBook.vue?vue&type=template&id=757ff02d&scoped=true"
import script from "./GalleryBook.vue?vue&type=script&lang=js"
export * from "./GalleryBook.vue?vue&type=script&lang=js"
import style0 from "./GalleryBook.vue?vue&type=style&index=0&id=757ff02d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757ff02d",
  null
  
)

export default component.exports